import { MONTHS, getDatePartsByMillis } from "components/CustomDatePicker/utils/helpers";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { useState } from "react";

const useNonBusinessDay = ({
	appliedFilters
}) => {
	const [day, setDay] = useState("");
	const dialog = useShowDialogAlert();
	function getDay() {
		const [year, month, date] = getDatePartsByMillis(appliedFilters.value.date);
        return `${date} ${MONTHS[month].substring(0, 3)} ${year}`;
	}
	const openDialog = () => {
		setDay(getDay());
		dialog.open();
	}
	return {
		day, dialog,
		openDialog
	};
}	
	
export default useNonBusinessDay;